import { AddEntityDialog } from "@/components/common/add-entity-dialog";
import { addProductBrandSchema } from "@/zod-schemas/products/add-product-brand-schema";
import { getProductBrandFormValues } from "@/default-form-values/products/default-product-brand-form-values";
import { useCreateProductBrand } from "@/hooks/products/use-product-brands";

export function AddBrandDialog() {
  const createBrand = useCreateProductBrand();

  return (
    <AddEntityDialog
      entityName="Brand"
      schema={addProductBrandSchema}
      defaultValues={getProductBrandFormValues}
      onCreate={async (data) => {
        await createBrand.mutateAsync({
          name: data.name,
        });
      }}
    />
  );
}
